module.exports = "<button class=\"btn bouton btn-block\" ng-click=\"$ctrl.ajouterAuStockageLocal()\">Ajouter au panier</button>"


//////////////////
// WEBPACK FOOTER
// ./src/ajouterPanier.component/ajouterPanier.html
// module id = 87
// module chunks = 0